import { getConsentThemeCss } from './consent-theme';
const servicesConfig = {
  amplitude: {
    name: 'Amplitude',
    type: 'analytic',
    uri: 'https://amplitude.com/privacy',
    cookies: []
  }
};
const services = Object.keys(servicesConfig);
const bannerTitles = {
  fr: 'Votre vie privée, vos choix',
  en: 'Your privacy, your choice',
  de: 'Ihre Privatsphäre, Ihre Wahl',
  es: 'Su privacidad, su elección'
};
const scriptId = 'geovelo-consent-manager';
const styleId = 'geovelo-consent-manager-theme';

/** CNIL recommends keeping the user's choice for 6 months before asking again. */
const choiceRetentionDays = 183;
export class ConsentService {
  static statuses = {
    amplitude: 'pending'
  };
  static listeners = [];
  static extraCookies = {};
  static initialized = false;
  static getStatus(service) {
    return ConsentService.statuses[service];
  }
  static subscribe(listener) {
    ConsentService.listeners.push(listener);
    return () => {
      ConsentService.listeners = ConsentService.listeners.filter(l => l !== listener);
    };
  }

  /** Cookies listed in the panel and removed by tarteaucitron when the service is refused. */
  static declareCookies(service, names) {
    ConsentService.extraCookies[service] = [...new Set([...(ConsentService.extraCookies[service] || []), ...names])];
  }
  static openPanel() {
    window.tarteaucitron?.userInterface.openPanel();
  }
  static init({
    delegated,
    basePath = '/tarteaucitron',
    language,
    privacyUrl,
    theme
  }) {
    if (typeof window === 'undefined' || ConsentService.initialized) return;
    ConsentService.initialized = true;
    if (delegated) {
      services.forEach(service => ConsentService.setStatus(service, 'granted'));
      return;
    }
    injectTheme({
      ...theme,
      bannerTitle: bannerTitles[language] || bannerTitles.fr
    });
    window.tarteaucitronForceLanguage = language;
    window.tarteaucitronForceExpire = choiceRetentionDays;
    const script = document.createElement('script');
    script.id = scriptId;
    script.src = `${basePath}/tarteaucitron.min.js`;
    script.async = true;
    script.onload = () => {
      const tarteaucitron = window.tarteaucitron;
      if (!tarteaucitron) return;
      tarteaucitron.init({
        privacyUrl,
        bodyPosition: 'top',
        hashtag: '#tarteaucitron',
        cookieName: 'tarteaucitron',
        orientation: 'bottom',
        groupServices: false,
        showDetailsOnClick: true,
        serviceDefaultState: 'wait',
        showAlertSmall: false,
        cookieslist: false,
        closePopup: false,
        showIcon: false,
        adblocker: false,
        DenyAllCta: true,
        AcceptAllCta: true,
        highPrivacy: true,
        alwaysNeedConsent: false,
        handleBrowserDNTRequest: false,
        removeCredit: true,
        moreInfoLink: true,
        useExternalCss: false,
        useExternalJs: false,
        mandatory: true,
        mandatoryCta: false,
        googleConsentMode: false,
        bingConsentMode: false,
        pianoConsentMode: false,
        piwikConsentMode: false,
        softConsentMode: false,
        dataLayer: false,
        serverSide: false,
        partnersList: false
      });
      tarteaucitron.job = tarteaucitron.job || [];
      services.forEach(key => {
        const {
          cookies,
          ...config
        } = servicesConfig[key];
        tarteaucitron.services[key] = {
          ...config,
          key,
          needConsent: true,
          readmoreLink: config.uri,
          cookies: [...cookies, ...(ConsentService.extraCookies[key] || [])],
          js: () => ConsentService.setStatus(key, 'granted'),
          // tarteaucitron also calls the fallback while the user has not made a choice yet, so a
          // refusal is only taken from the stored choice or from the `_disallowed` event.
          fallback: () => {
            if (tarteaucitron.cookie.read().includes(`!${key}=false`)) {
              ConsentService.setStatus(key, 'denied');
            }
          }
        };
        document.addEventListener(`${key}_allowed`, () => ConsentService.setStatus(key, 'granted'));
        document.addEventListener(`${key}_disallowed`, () => ConsentService.setStatus(key, 'denied'));
        tarteaucitron.job?.push(key);
      });
    };
    document.head.appendChild(script);
  }
  static setStatus(service, status) {
    if (ConsentService.statuses[service] === status) return;
    ConsentService.statuses[service] = status;
    ConsentService.listeners.forEach(listener => listener(service, status));
  }
}
function injectTheme(theme) {
  if (document.getElementById(styleId)) return;
  const style = document.createElement('style');
  style.id = styleId;
  style.textContent = getConsentThemeCss(theme);
  document.head.appendChild(style);
}